export default __webpack_public_path__ + "static/media/GoudyBookletter.dc1ce51e.woff";